/* eslint-disable camelcase */
import moment from 'moment';
import React, { Component } from 'react';
import { Row, DatePicker, Radio, Spin, TreeSelect } from 'antd';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Echart from '../../../../components/Echart';
import xfetch from '../../../../xfetch';
import { backendErrorTip } from '../../../../utils';
import { createQuestion, ask, love } from './lineOption';
import s from './style.css';

const { RangePicker } = DatePicker;
const { TreeNode } = TreeSelect;
const { Group: RadioGroup, Button: RadioButton } = Radio;

@withStyles(s)
export default class Statistics extends Component {
  constructor(props) {
    super(props);
    this.q = {
      range: '',
    };
    this.baseApi = `${window.G.backendApi}/statistics/answer/`;
    this.orgTreeApi = `${window.G.backendApi}/profiles/organization/tree/`;
  }
  state = {
    dates: [],
    loading: true,
    startTime: moment()
      .startOf('week')
      .format('YYYY-MM-DD'),
    endTime: moment().format('YYYY-MM-DD'),
    answer_create_time: [],
    ask_times: [],
    hit_times: [],
    miss_times: [],
    up_times: [],
    down_times: [],
    answerTotal: 0,
    organization: '',
    treeNodes: [],
    total: {},
  };
  componentDidMount() {
    this.queryOrgTree().then(this.refreshDashboard);
  }
  onDateSelect = e => {
    const range = e.target.value;
    const startTime = moment()
      .startOf(range)
      .format('YYYY-MM-DD');
    const endTime = moment().format('YYYY-MM-DD');
    this.setState(
      {
        startTime,
        endTime,
        dates: [],
      },
      () => {
        this.refreshDashboard();
      },
    );
  };
  onDateChange = range => {
    const startTime = moment(range[0]).format('YYYY-MM-DD');
    const endTime = moment(range[1]).format('YYYY-MM-DD');
    this.setState(
      {
        dates: [],
        startTime,
        endTime,
      },
      () => {
        this.refreshDashboard();
      },
    );
  };
  onOrgChange = organization => {
    this.setState(
      {
        organization,
        dates: [],
      },
      () => {
        this.refreshDashboard();
      },
    );
  };
  refreshDashboard = async () => {
    const { startTime, endTime, organization } = this.state;
    let queryApi = `${this.baseApi}?organization_id=${organization}&create_time__range=${startTime},${endTime}`;

    if (organization) {
      queryApi += `&organization=${organization}`;
    }
    const { result, error } = await xfetch(queryApi);
    this.setState({
      loading: false,
    });
    if (error) {
      backendErrorTip('获取统计数据失败');
      return;
    }

    const {
      hit_times,
      miss_times,
      ask_times,
      dates,
      down_times,
      up_times,
      answer_create_time,
    } = result.by_date;
    this.setState({
      dates,
      hit_times,
      miss_times,
      ask_times,
      up_times,
      down_times,
      answerTotal: 0,
      answer_create_time,
      total: result.total,
    });
  };
  queryOrgTree = async () => {
    const { error, result } = await xfetch(this.orgTreeApi);
    return new Promise((resolve, reject) => {
      if (error) {
        backendErrorTip(error);
        reject();
        return;
      }
      this.setState(
        {
          organization: (Object.values(result.tree)[0] || {}).id,
          treeNodes: result.tree,
        },
        resolve,
      );
    });
  };
  renderTreeNodes = tree => {
    const data = Object.values(tree);
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode
            disabled={item.deprecated}
            key={item.id}
            value={item.id}
            title={item.name}
          >
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          value={item.id}
          disabled={item.deprecated}
          title={item.name}
        />
      );
    });
  };
  render() {
    const {
      answer_create_time: answerCreateTime,
      ask_times: askTimes,
      hit_times: hitTimes,
      miss_times: missTimes,
      down_times: downTimes,
      up_times: upTimes,
      loading,
      dates,
      treeNodes,
      organization,
      total,
    } = this.state;
    const orgTreeNodes = this.renderTreeNodes(treeNodes);
    return (
      <div className={s.wrap}>
        <Spin spinning={loading}>
          <div style={{ marginBottom: 15 }}>
            <span style={{ marginRight: 25 }}>
              新增问题总数：<b>{total.answer || 0}</b>
            </span>
            <span style={{ marginRight: 25 }}>
              提问总数：<b>{total.ask_times || 0}</b>
            </span>
            <span style={{ marginRight: 25 }}>
              已知问题提问总数：<b>{total.hit_times || 0}</b>
            </span>
            <span style={{ marginRight: 25 }}>
              未知问题提问总数：<b>{total.miss_times || 0}</b>
            </span>
            <span style={{ marginRight: 25 }}>
              点赞总数：<b>{total.up_times || 0}</b>
            </span>
            <span style={{ marginRight: 25 }}>
              点踩总数：<b>{total.down_times || 0}</b>
            </span>
          </div>
          <Row>
            <div style={{ float: 'left' }}>
              组织机构：
              <TreeSelect
                showSearch
                value={organization}
                style={{ width: 140 }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="请选择"
                allowClear
                onChange={this.onOrgChange}
                treeDefaultExpandAll
              >
                {orgTreeNodes}
              </TreeSelect>
            </div>
            <div style={{ float: 'left', marginLeft: 20 }}>
              日期范围筛选：
              <RadioGroup onChange={this.onDateSelect} defaultValue="week">
                <RadioButton value="week">本周</RadioButton>
                <RadioButton value="month">本月</RadioButton>
                <RadioButton value="quarter">本季度</RadioButton>
              </RadioGroup>
              <RangePicker
                onChange={this.onDateChange}
                style={{ marginLeft: 10 }}
              />
            </div>
          </Row>

          <div style={{ height: 300, marginTop: 40 }}>
            {dates.length ? (
              <Echart
                option={createQuestion(
                  dates,
                  answerCreateTime,
                  '创建问题数统计',
                )}
              />
            ) : null}
          </div>
          <div style={{ height: 300, marginTop: 40 }}>
            {dates.length ? (
              <Echart
                option={ask(
                  dates,
                  askTimes,
                  hitTimes,
                  missTimes,
                  '提问次数统计',
                )}
              />
            ) : null}
          </div>
          <div style={{ height: 300, marginTop: 40 }}>
            {dates.length ? (
              <Echart
                option={love(dates, upTimes, downTimes, '点赞点踩统计')}
              />
            ) : null}
          </div>
        </Spin>
      </div>
    );
  }
}
